// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6oeHTqYvx{text-decoration:none;color:inherit;width:100%}._4EuopwFAx{padding-top:16px;display:flex;direction:row;justify-content:space-between;border-bottom:solid 1px #dedede;padding-bottom:16px;background-color:#fff}._4mtBwf2Ix{opacity:.5}", "",{"version":3,"sources":["webpack://client/install-beacon/components/list-item-link/list-item-link.scss"],"names":[],"mappings":"AAEA,YACE,oBAAA,CACA,aAAA,CACA,UAAA,CAGF,YACE,gBAAA,CACA,YAAA,CACA,aAAA,CACA,6BAAA,CACA,+BAAA,CACA,mBAAA,CACA,qBAAA,CAGF,YAEE,UAAA","sourcesContent":["@import \"~@css/vars.scss\";\n\n.list-item-link {\n  text-decoration: none;\n  color: inherit;\n  width: 100%;\n}\n\n.list-item {\n  padding-top: 16px;\n  display: flex;\n  direction: row;\n  justify-content: space-between;\n  border-bottom: solid 1px $gray-light1;\n  padding-bottom: 16px;\n  background-color: #FFFFFF;\n}\n\n.list-item-grayed {\n  composes: list-item;\n  opacity: .5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1faece",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#f7e28b",
	"violetLight2": "#cec0ec",
	"tealLight3": "#cfece8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"list-item-link": "_6oeHTqYvx",
	"listItemLink": "_6oeHTqYvx",
	"list-item": "_4EuopwFAx",
	"listItem": "_4EuopwFAx",
	"list-item-grayed": "_4mtBwf2Ix _4EuopwFAx",
	"listItemGrayed": "_4mtBwf2Ix _4EuopwFAx"
};
export default ___CSS_LOADER_EXPORT___;
